export enum QuestionTypes {
    UNIQUE = 1,
    MULTIPLE = 2,
    TEXT = 3,
    BOOL = 4
}
